"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactPlayer = _interopRequireDefault(require("react-player"));
var _dateFns = require("date-fns");
var _reactSpinners = require("react-spinners");
var _Button = _interopRequireDefault(require("../Button"));
var _index = _interopRequireDefault(require("../hooks/useMediaPlayback/index"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ReactPlayer = _reactPlayer.default;
var VideoPlayer = function VideoPlayer(_ref) {
  var filename = _ref.filename,
    timestamp = _ref.timestamp,
    getUrl = _ref.getUrl,
    reactPlayerClassName = _ref.reactPlayerClassName,
    styles = _ref.styles,
    _ref$videoHeight = _ref.videoHeight,
    videoHeight = _ref$videoHeight === void 0 ? 'auto' : _ref$videoHeight,
    _ref$videoWidth = _ref.videoWidth,
    videoWidth = _ref$videoWidth === void 0 ? '100%' : _ref$videoWidth,
    _ref$playerWidth = _ref.playerWidth,
    playerWidth = _ref$playerWidth === void 0 ? '100%' : _ref$playerWidth;
  var _useMediaPlayback = (0, _index.default)(getUrl),
    isLoading = _useMediaPlayback.isLoading,
    error = _useMediaPlayback.error,
    setError = _useMediaPlayback.setError,
    secondsPlayed = _useMediaPlayback.secondsPlayed,
    setSecondsPlayed = _useMediaPlayback.setSecondsPlayed,
    durationInSeconds = _useMediaPlayback.durationInSeconds,
    setDurationInSeconds = _useMediaPlayback.setDurationInSeconds,
    playbackImgInfo = _useMediaPlayback.playbackImgInfo,
    handlePlaybackClick = _useMediaPlayback.handlePlaybackClick,
    isPlaying = _useMediaPlayback.isPlaying,
    setIsPlaying = _useMediaPlayback.setIsPlaying,
    mediaPlayer = _useMediaPlayback.mediaPlayer,
    isMuted = _useMediaPlayback.isMuted,
    formattedTimeInfo = _useMediaPlayback.formattedTimeInfo,
    mediaUrl = _useMediaPlayback.mediaUrl,
    hasEnded = _useMediaPlayback.hasEnded,
    setHasEnded = _useMediaPlayback.setHasEnded,
    reactPlayerId = _useMediaPlayback.reactPlayerId;

  /** Components */

  var renderVideoTitle = function renderVideoTitle() {
    return /*#__PURE__*/_react.default.createElement("h3", {
      className: "heading"
    }, filename !== null && filename !== void 0 ? filename : 'Video');
  };
  var renderPlaceholder = function renderPlaceholder() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "video placeholder",
      "aria-label": "video placeholder"
    }, isLoading && /*#__PURE__*/_react.default.createElement(_reactSpinners.ClipLoader, {
      color: "#7E7E7E",
      size: 28
    }), !!error && renderErrorMessage(), !isLoading && !hasEnded && !error && /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: handlePlaybackClick,
      "aria-label": "Start Video",
      disabled: isLoading
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: playbackImgInfo.largeSrc,
      alt: playbackImgInfo.alt
    })));
  };
  var renderProgressInfo = function renderProgressInfo() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "seek-bar-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "time-elapsed"
    }, formattedTimeInfo.elapsed), /*#__PURE__*/_react.default.createElement("div", {
      className: "seek-bar"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "elapsed-duration",
      style: {
        width: durationInSeconds ? "".concat(100 * secondsPlayed / durationInSeconds, "%") : 0
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "total-time"
    }, formattedTimeInfo.total));
  };
  var renderLoadingSpinner = function renderLoadingSpinner() {
    return /*#__PURE__*/_react.default.createElement(_reactSpinners.ClipLoader, {
      color: "#458DC9",
      size: 16
    });
  };
  var renderTimestamp = function renderTimestamp() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "timestamp-container"
    }, (0, _dateFns.format)(new Date(timestamp), 'HH:mm'));
  };
  var renderErrorMessage = function renderErrorMessage() {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "error"
    }, error);
  };
  var renderPlayPauseReplayButton = function renderPlayPauseReplayButton() {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: handlePlaybackClick,
      "aria-label": playbackImgInfo.alt,
      disabled: !!error || isLoading
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: playbackImgInfo.src,
      alt: playbackImgInfo.alt,
      style: {
        marginLeft: !isPlaying ? 4 : 0
      }
    }));
  };
  var Player = /*#__PURE__*/_react.default.createElement(ReactPlayer, {
    ref: mediaPlayer,
    className: (0, _classnames.default)(reactPlayerClassName !== null && reactPlayerClassName !== void 0 ? reactPlayerClassName : '', 'react-player'),
    id: reactPlayerId,
    url: mediaUrl,
    playing: isPlaying,
    controls: false,
    muted: isMuted,
    progressInterval: 250,
    onProgress: function onProgress(state) {
      return setSecondsPlayed(state.playedSeconds);
    },
    onPlay: function onPlay() {
      setHasEnded(false);
      setIsPlaying(true);
    },
    onDuration: function onDuration(seconds) {
      return setDurationInSeconds(seconds);
    },
    onBuffer: function onBuffer() {},
    onBufferEnd: function onBufferEnd() {},
    onSeek: function onSeek() {},
    onEnded: function onEnded() {
      return setHasEnded(true);
    },
    onError: function onError() {
      setError('A playback error occurred');
      setIsPlaying(false);
    },
    width: "100%",
    height: videoHeight,
    style: styles !== null && styles !== void 0 ? styles : {}
  });
  var shouldRenderPlayer = !isLoading && mediaUrl && !error;
  var renderControls = function renderControls() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "controls"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "play-pause"
    }, isLoading ? renderLoadingSpinner() : renderPlayPauseReplayButton()), renderProgressInfo());
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-video-player-wrapper",
    style: {
      width: playerWidth
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-video-player",
    style: {
      width: videoWidth
    }
  }, renderVideoTitle(), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shouldRenderPlayer ? Player : renderPlaceholder(), renderControls()), renderTimestamp()));
};
var _default = VideoPlayer;
exports.default = _default;